import { useEffect, useRef } from 'react';
import { useCommandStore } from '../../lib/commands.ts';
import { isTypingTarget } from '@orgus/ui';

/**
 * Single-key shortcuts that belong to one page, active while it is mounted. Like the global
 * ones they never fire while typing, with a modifier held, or while a dialog, drawer, menu or
 * the palette is open.
 */
export function usePageKeys(map: Record<string, () => void>): void {
  const ref = useRef(map);
  ref.current = map;
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.defaultPrevented || e.isComposing || e.ctrlKey || e.metaKey || e.altKey) return;
      if (isTypingTarget(e.target)) return;
      if (useCommandStore.getState().paletteOpen) return;
      if (document.querySelector('[role="dialog"][data-state="open"], [role="menu"][data-state="open"]')) return;
      const fn = ref.current[e.key];
      if (!fn) return;
      e.preventDefault();
      fn();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);
}
